import React, { useEffect, useState, useRef } from "react";
import Close from "../../images/x-circle.svg";

import "./CommonModal.css";

function CommonPopup({
  isOpen,
  onClose,
  title,
  size,
  className,
  position,
  children,
  isOutsideClick,
}) {
  const [animClass, setAnimClass] = useState("");
  const popupRef = useRef(null);

  const handleOutsideClick = (e) => {
    if (
      isOutsideClick &&
      popupRef.current &&
      !popupRef.current.contains(e.target) &&
      isOpen
    ) {
      onClose();
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.querySelector("body").classList.add("body_scroll_hid");
      setAnimClass("visible");
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.querySelector("body").classList.remove("body_scroll_hid");
      setAnimClass("invisible");
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen, isOutsideClick]);

  return isOpen ? (
    <div className={`common_modal ${className ? className : ""}`}>
      <div
        ref={popupRef}
        className={`common_modal_content popupAnim scBarHidden transform ${size} ${animClass} ${position}`}
      >
        <div className="common_model_head">
          <h3>{title}</h3>
          <span className="close-button" onClick={onClose}>
            <img src={Close} alt="Close" className="w-5 h-5" />
          </span>
        </div>
        <div className="common_model_body">{children}</div>
      </div>
    </div>
  ) : null;
}

export default CommonPopup;
